export const TODO_QUERY_KEY = {
  ALL: ['todo'],
  TODO_LIST: () => [...TODO_QUERY_KEY.ALL, 'todoList'],
};
